import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react'

export default function ConfirmDeleteModal({ isOpen, onOpenChange, onConfirm, title, message, children, isPending }) {
  return (
    <>
      {children}
      <Modal radius="sm" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>{message}</ModalBody>
          <ModalFooter>
            <Button radius="sm" variant="light" onPress={onOpenChange}>Cancel</Button>
            <Button radius="sm" color="danger" onPress={onConfirm} isLoading={isPending}>Confirm</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
